import type { NewsArticle } from '@/types/news';
import { newsList } from '@/mocks/news';

export type TimeRange = 'all' | '24h' | '7d';
export type SortKey = 'latest' | 'hot';

export function sortByDateDesc(list: NewsArticle[]): NewsArticle[] {
  return [...list].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  );
}

export function filterByTime(list: NewsArticle[], range: TimeRange): NewsArticle[] {
  if (range === 'all') return list;
  const now = Date.now();
  const span = range === '24h' ? 24 * 60 * 60 * 1000 : 7 * 24 * 60 * 60 * 1000;
  return list.filter((item) => now - new Date(item.publishedAt).getTime() <= span);
}

export function sortArticles(list: NewsArticle[], sort: SortKey): NewsArticle[] {
  if (sort === 'hot') return [...list].sort((a, b) => b.views - a.views);
  return sortByDateDesc(list);
}

export function getByCategory(categoryId: string): NewsArticle[] {
  return newsList.filter((item) => item.category === categoryId);
}

export function searchNews(keyword: string): NewsArticle[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return newsList.filter((item) => {
    const text = [
      item.title,
      item.summary,
      item.content.join(' '),
      item.tags.join(' '),
    ]
      .join(' ')
      .toLowerCase();
    return text.includes(q);
  });
}

export function getRelated(article: NewsArticle, limit = 4): NewsArticle[] {
  const sameCategory = sortByDateDesc(
    newsList.filter((item) => item.id !== article.id && item.category === article.category),
  );
  const others = sortByDateDesc(
    newsList.filter((item) => item.id !== article.id && item.category !== article.category),
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function getById(id: string): NewsArticle | undefined {
  return newsList.find((item) => item.id === id);
}